import React, { Component } from 'react'
import { Select } from 'loyal-react'
import PropTypes from 'prop-types'

class SelectAreaCode extends Component {
  constructor (props) {
    super(props)

    this.props.getAreaCodes(this.props.operatorKey)
  }

  componentDidUpdate (prevProps) {
    if (
      (this.props.areaCodes || this.props.areaCodes.length > 0) &&
      !this.props.operatorKey
    ) {
      this.props.clearAreaCodes()
    }
    if (this.props.operatorKey !== prevProps.operatorKey) {
      this.props.getAreaCodes(this.props.operatorKey)
    }
  }

  render () {
    return (
      <Select
        id='dataDDD'
        label='DDD'
        className='col-4'
        displayValue='description'
        selectedValue='areaCode'
        options={this.props.areaCodes}
        onChange={e => this.props.onChangeAreaCode(e)}
        value={this.props.areaCodes.find(
          item => item.areaCode === this.props.areaCode
        )}
        disabled={this.props.disabled}
        required={this.props.required}
        key={this.props.areaCode}
      />
    )
  }
}

SelectAreaCode.propTypes = {
  areaCodes: PropTypes.array,
  onChangeAreaCode: PropTypes.func,
  getAreaCodes: PropTypes.func,
  operatorKey: PropTypes.string,
  areaCode: PropTypes.string,
  disabled: PropTypes.bool,
  clearAreaCodes: PropTypes.func,
  required: PropTypes.bool
}

export default SelectAreaCode



// WEBPACK FOOTER //
// ./src/features/CellphoneRecharge/PhoneNumber/SelectAreaCode/SelectAreaCode.js